import { React, useCallback, useState } from "react";

// components
import Loader from "../../components/loader";
import Logo from "../../components/logo";
import SearchResultsSection from "./components/search-results";
import PatientSearchForm from "./components/patient-search-form";

// hooks
import useFetchHandler from "../../hooks/use-fetch-handler";
import BackButton from "../../components/back-button";

export default function PatientSearchPage() {
    const [searchResults, setSearchResults] = useState('')
    const [showSearchResultsSection, setSearchResultsSection] = useState(false)

    const {
        loading,
        error,
        handleFetch,
    } = useFetchHandler();

    const handleFetchSearchResults = useCallback(async (requestBody) => {
        await handleFetch(
            "POST",
            "patient/search",
            JSON.stringify(requestBody),
            true,
            (data) => {
                setSearchResults(data?.patients)
                setSearchResultsSection(true);
                window.scrollTo(0, 0);
            }
        )
    }, [handleFetch])


    return (
        <>
            {!loading && (
                <main
                    className={`relative flex-grow flex flex-col items-center justify-center p-10 gap-20`}
                >
                    <BackButton />
                    <Logo />
                    {showSearchResultsSection ? (
                        <SearchResultsSection
                            searchResults={searchResults}
                        />
                    ) : (
                        <PatientSearchForm
                            handleFetchSearchResults={handleFetchSearchResults}
                            fetchError={error}
                        />
                    )}
                </main>
            )}
            {loading && (
                <Loader
                    message={'Searching Clients, '}
                />
            )}
        </>
    );
}
